import { FieldEditorProps } from './FieldEditorProps';
import '../styles/Editors.scoped.scss';

export const OrganisationFieldEditor = ({ field, onChange }: FieldEditorProps) => {
  const organisationKinds = window.ENV.ORGANISATION_KINDS || []
  const organisationKindOptions = organisationKinds
      .map((kind) => ({
        value: kind.external_type,
        label: kind.label || kind.name || kind.external_type
      }))
      .filter((option) => option.value)

  return <>
    <div className="field-editor-row">
      <label>Organisation Type</label>
      <div className='field-editor-input'>
        <select
          className="source-selector"
          value={field.organisationKind ?? ''}
          onChange={(e) =>
            onChange({ organisationKind: e.target.value || null })
          }
        >
          <option value="">Select organisation kind</option>
          {organisationKindOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  </>
}
